/**
 * Initializes the alert service for the web by setting up an showNotification (Portal) handler.
 * Once initialized, alerts can be displayed anywhere in the app by calling alertService.alert()
 */

import { removeSnackBar, showBasicSnackBar } from '@aquariuxfintech/aqx-trader-react-ui/snack-bar';

import { IUIBasicSnackBarProps, snackbarController } from '@aqx-core/common/services/snackbar';

export const useInitWebAlert = () => {
  const webAlert = {
    alert: (params: IUIBasicSnackBarProps) => showBasicSnackBar(params),
    close: (id: string) => removeSnackBar(id)
  };

  snackbarController.setSnackbarHandler(webAlert);
};
